









































import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from 'vuex-module-decorators';
import Navigation from '@/store/modules/Navigation';
import { Auth } from "aws-amplify";
import { Urls } from "@/Urls";

const navigationModule = getModule(Navigation);

@Component({
    components: {}
})
export default class Verify extends Vue {

    @Prop({required: true})
    username!: string;

    @Prop({required: true})
    confirmationCode!: string;

    private verifying = true;
    private error: string | null = null;

    mounted() {
        this.initialize();
    }

    private async initialize() {
        Auth.confirmSignUp(this.username, this.confirmationCode)
        .then(res => {
            navigationModule.setAnonUserId('verifying');
            this.$router.push(Urls.LOGIN);
            // if(Vue.$cookies.isKey('app-share-url')){
            //     this.$router.push(Vue.$cookies.get('app-share-url'));
            // }else{
            //     this.$router.push(Urls.LOGIN);
            // }
        })
        .catch(err => {
            this.verifying = false;
            this.error = err.message;
            setTimeout(() => this.$router.push(Urls.SIGNUP), 3000);
        });
    }

}
